import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useHistory, useParams } from 'react-router';
import DashboardWrapper from '../../../Shared/DashboardWrapper';
import { ReactComponent as BlackInverseTick } from '../../../Shared/svgs/tick-ef-black.svg';
import { getExternalLink } from '../../../../lib/api/external-link';
import { getEnquiryFunctionalityFeatureFlag } from '../../../../lib/api/enquiry-functionality';
import { getAccountNumber } from '../../../../lib/api/localstorage';
import { clearDraft } from '../RaiseEnquiry/raiseEnquiryForm';

export default function EnquiryConfirmation() {
    const { reference } = useParams();
    const [helpLink, setHelpLink] = useState('');
    const history = useHistory();
    const accountNumber = getAccountNumber();

    useEffect(() => {
        getEnquiryFunctionalityFeatureFlag()
            .then((resp) => {
                if (resp?.data?.data !== true) history.push('/dashboard/main');
            })
            .catch(() => {
                history.push('/dashboard/main');
            });
    }, [history]);

    useEffect(() => {
        clearDraft(window.sessionStorage);
    }, []);

    useEffect(() => {
        getExternalLink()
            .then((resp) => setHelpLink(resp.data.faqLink))
            .catch(() => setHelpLink(''));
    }, []);

    return (
        <DashboardWrapper helpLink={helpLink}>
            <div className="main-dashboard" id="enquiry-confirmation-page">
                <div className="enquiry-confirmation__banner" id="enquiry-confirmation-banner">
                    <BlackInverseTick className="enquiry-confirmation__tick" />
                    <div>
                        <p className="enquiry-confirmation__title" id="enquiry-confirmation-title">
                            Thank you — your enquiry has been sent.
                        </p>
                        <p className="enquiry-confirmation__subtitle" id="enquiry-confirmation-subtitle">
                            Reference{' '}
                            <strong className="enquiry-confirmation__reference" id="enquiry-confirmation-reference">
                                {reference}
                            </strong>
                            {accountNumber ? ` · linked to account ${accountNumber}` : ''}
                        </p>
                    </div>
                </div>

                <p className="raise-enquiry__hint enquiry-confirmation__note" id="enquiry-confirmation-note">
                    Your enquiry can no longer be changed. You can follow its progress from your enquiries page.
                </p>

                <div className="raise-enquiry__footer raise-enquiry__footer--confirmation">
                    <Link to="/enquiries" className="enquiries-tile__btn" id="enquiry-confirmation-track">
                        Track your enquiries
                    </Link>
                    <Link
                        to="/dashboard/main"
                        className="enquiries-tile__btn enquiries-tile__btn--secondary"
                        id="enquiry-confirmation-dashboard"
                    >
                        Back to dashboard
                    </Link>
                </div>
            </div>
        </DashboardWrapper>
    );
}
